import { OrganisationType, UserType } from "./enum";

export const PAGINATION_CONFIG = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100, // Prevent excessive page sizes
} as const;

// Define error messages
export const ERROR_MESSAGES = {
  INVALID_DATE: "Invalid date format",
  INVALID_PAGE: "Invalid page number",
  INVALID_LIMIT: "Invalid limit number",
  INTERNAL_ERROR: "Internal server error",
  UNAUTHORIZE_ERROR: "Please log in with an authorized account to continue",
  SOMETHING_WENT_WRONG: "Something went wrong!!",
  DO_NOT_AUTHORIZE: "You are not authorized to perform this action",
} as const;

export const DEFAULT_ROLE = "officeholder" as const;
export const DEFAULT_TYPE = "client" as const;
// export const DATE_FORMAT = "MMM DD, yyyy" as const;
export const DATE_FORMAT = "DD/MM/YYYY" as const;
export const DATE_TIME_FORMAT = "DD/MM/YYYY hh:mm A" as const;

export const AUTHORIZED_LOGIN_TYPES = [
  UserType.SuperAdmin,
  UserType.Admin,
  UserType.LoanWriter,
];

export const PERMITTED_ORGANIZATIONS_TYPES = [
  OrganisationType.Gallantree,
  OrganisationType.FundManager,
];

export const ASSOCIATED_ORGANISATIONS_TYPES = [
  OrganisationType.Borrower,
  OrganisationType.Broker,
];

export const EXPORT_FORMATS = {
  CSV: "csv",
  EXCEL: "excel",
  PDF: "pdf",
} as const;

export type EXPORT_FORMAT = {
  format: keyof typeof EXPORT_FORMATS;
};

export const DOWNLOAD_FORMAT: Record<string, string> = {
  csv: "csv",
  pdf: "pdf",
  excel: "xlsx",
};

export const CREDITORWATCH_BASE_URL = process.env.CREDITORWATCH_BASE_URL;

export const VALID_CREDIT_RATINGS = [
  "A1",
  "A2",
  "A3",
  "B1",
  "B2",
  "B3",
  "C1",
  "C2",
];

export const NO_DATA_AVAILABLE = "-";

export const NAVBAR_BG_HEXACODE = [
  "tw-bg-[#9B92AB]",
  "tw-bg-[#96A1C0]",
  "tw-bg-[#A0D3A1]",
  "tw-bg-[#FEE798]",
  "tw-bg-[#F8CA97]",
  "tw-bg-[#EC9195]",
];
